/* eslint-disable prefer-template */

const getLocationOrigin = () => {
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname}${port ? ':' + port : ''}`;
};

// Web example:
// https://dev.app.imaginarie.app/auth/action?apiKey=AIzaSyC1tjBDvojenc8e6HByWRv7YUjOs3_V_ZI&mode=resetPassword&oobCode=xQWsCbkHmuB2HyxSKfF40EhAAXmLp_F8CqafGhjc6tMAAAFyUxSfpg&continueUrl=http://localhost:8080/auth&lang=en

// Native deep-link example:
// https://dev.link.imaginarie.app?link=
//  https://dev.app.imaginarie.app/auth/action?apiKey%3DAIzaSyC1tjBDvojenc8e6HByWRv7YUjOs3_V_ZI%26mode%3DresetPassword%26oobCode%3D8y50MSSILYahwzn4tb6ff76mKz7iNsSd03YJSgPe7ucAAAFyVCRkYA%26continueUrl%3Dhttps://dev.app.imaginarie.app%26lang%3Den
//  &apn=app.imaginarie.app.dev&amv=23&ibi=app.imaginarie.app.dev&ifl=https://dev.app.imaginarie.app/auth/action?apiKey%3DAIzaSyC1tjBDvojenc8e6HByWRv7YUjOs3_V_ZI%26mode%3DresetPassword%26oobCode%3D8y50MSSILYahwzn4tb6ff76mKz7iNsSd03YJSgPe7ucAAAFyVCRkYA%26continueUrl%3Dhttps://dev.app.imaginarie.app%26lang%3Den
// Special characters are escaped

const getAuthParams = url => {
  const isDeepLink = url.indexOf('link.imaginarie') > -1;
  const ampersand = isDeepLink ? '%26' : '&';
  const equalsSign = isDeepLink ? '%3D' : '=';

  const paramArray = url
    .split('auth/action?')[1]
    .split('&apn')[0]
    .split(ampersand);

  const params = {};
  paramArray.forEach(param => {
    const [key, value] = param.split(equalsSign);
    params[key] = value;
  });
  return params;
};

export { getLocationOrigin, getAuthParams };
